import { render, staticRenderFns } from "./Media_Manage.vue?vue&type=template&id=4ad47f7c&"
import script from "./Media_Manage.vue?vue&type=script&lang=js&"
export * from "./Media_Manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports